export default __webpack_public_path__ + "static/gdpr-7d6958a696026b0b3fa1d88111101d45.webp";